import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../../../../theme/palette';

const style = () =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    relaisLine: {
      padding: '10px',
      display: 'flex',
      justifyContent: 'space-between',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: palette.background.underBox
      }
    },
    selectedLine: {
      margin: '10px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
